import moment, { Moment } from "moment";
import { TipoEvento } from "./enum";

export interface IEvento {
  id: string;
  processo?: string;
  codigoAtivo: string;
  dataCredito: Moment;
  dataEx: Moment;
  tipo: TipoEvento;
  subtipo?: string;
  valor?: number;
  fator?: number;
  codigoObjeto?: string;
  isinAtivo?: string;
  isinObjeto?: string;
  precoMedio?: number;
}

export class Evento implements IEvento {
  public id!: string;
  public processo?: string;
  public codigoAtivo!: string;
  public dataCredito!: Moment;
  public dataEx!: Moment;
  public tipo!: TipoEvento;
  public subtipo?: string;
  public valor?: number;
  public fator?: number;
  public codigoObjeto?: string;
  public isinAtivo?: string;
  public isinObjeto?: string;
  public precoMedio?: number;

  constructor(param: IEvento) {
    Object.assign(this, param);
  }

  static fromFirestore(obj: any): Evento {
    let evento: IEvento = {
      id: obj.id,
      tipo: obj.tipo,
      dataEx: moment(obj.dataEx.toDate()),
      dataCredito: moment(obj.dataCredito.toDate()),
      codigoAtivo: obj.codigoAtivo,
      subtipo: obj.subtipo,
    };
    switch (evento.tipo) {
      case TipoEvento.AMORTIZACAO:
        evento.valor = obj.valor;
        break;
      case TipoEvento.ATUALIZACAO:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        break;
      case TipoEvento.BONIFICACAO:
        evento.fator = obj.fator;
        evento.valor = obj.valor;
        // Bonificação em outra classe (ex.: CYRE3 → CYRE4); ausente na
        // bonificação tradicional no mesmo ticker.
        evento.codigoObjeto = obj.codigoObjeto;
        break;
      case TipoEvento.CISAO:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        evento.valor = obj.valor;
      case TipoEvento.DESDOBRAMENTO:
        evento.fator = obj.fator;
        break;
      case TipoEvento.DIVIDENDO:
        evento.valor = obj.valor;
        break;
      case TipoEvento.GRUPAMENTO:
        evento.fator = obj.fator;
        break;
      case TipoEvento.INCORPORACAO:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        evento.precoMedio = obj.precoMedio;
        break;
      case TipoEvento.JUROS:
        evento.valor = obj.valor;
        break;
      case TipoEvento.RENDIMENTO:
        evento.valor = obj.valor;
        break;
      case TipoEvento.RESTITUICAO_ACOES:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        evento.valor = obj.valor;
        break;
      case TipoEvento.SUBSCRICAO_DISTRIBUICAO:
        evento.fator = obj.fator;
        evento.codigoObjeto = obj.codigoObjeto;
        evento.isinObjeto = obj.isinObjeto;
        break;
      case TipoEvento.SUBSCRICAO_EXERCICIO:
        evento.valor = obj.valor;
        evento.codigoObjeto = obj.codigoObjeto;
        evento.isinAtivo = obj.isinAtivo;
        break;
      case TipoEvento.DISSOLUCAO:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        evento.precoMedio = obj.precoMedio;
        break;
      case TipoEvento.LIQUIDACAO:
        evento.codigoObjeto = obj.codigoObjeto;
        evento.fator = obj.fator;
        evento.valor = obj.valor;
        break;
      default:
        break;
    }
    return new Evento(evento);
  }
}
